import React from 'react';
import { Box, VStack, Text, Spinner, Center } from '@chakra-ui/react';

interface LoadingStateProps {
    message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message }) => {
    return (
        <Box flex={1} bg="gray.100" display="flex" alignItems="center" justifyContent="center" minH="100vh">
            <Center>
                <VStack gap={4}>
                    <Spinner size="xl" color="yellow.600" />
                    {message && (
                        <Text fontSize="lg" color="gray.700" fontWeight="medium">
                            {message}
                        </Text>
                    )}
                </VStack>
            </Center>
        </Box>
    );
};

export default LoadingState;
